<template>
  <div :class="classes">
    <div class="card my-2">
      <div class="card-header column-handle">
        Column
        <div class="btn-group float-right">
          <b-dropdown id="dropdown-1" text="Ширина">
            <b-dropdown-item @click="update_col('classes', 'col-md-1')"
              >8%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-2')"
              >16%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-3')"
              >25%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-4')"
              >33%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-5')"
              >41%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-6')"
              >50%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-7')"
              >58%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-8')"
              >66%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-9')"
              >75%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-10')"
              >83%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-11')"
              >91%</b-dropdown-item
            >
            <b-dropdown-item @click="update_col('classes', 'col-md-12')"
              >100%</b-dropdown-item
            >
          </b-dropdown>
          <button class="btn btn-danger" @click="remove_column">&times;</button>
        </div>
      </div>
      <draggable
        v-model="items_"
        handle=".field-handle"
        @input="reorder_items"
        group="elements"
        @change="elements_changed"
        tag="div"
        :class="['px-4 py-2 rounded mb-3 row']"
      >
        <sb-element
          v-for="(item, index) in items_"
          :key="'sbelement-' + (index + col_index)"
          :item="item"
          @element_change="element_change($event, index)"
          @remove_element="remove_element(index)"
        ></sb-element>
      </draggable>
      <div class="card-footer">
      <button class="btn btn-light" @click="add_element">Add field</button>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  computed: {
    width_name() {
      return "width-" + this._uid;
    },
  },
  data() {
    return {
      items_: [],
    };
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    classes: {
      type: String,
      default: "col",
    },
    id: {
      type: String,
      default: "",
    },
    col_index: {
      type: String,
      default: "0",
    },
  },
  mounted() {
    this.items_ = this.items;
  },
  methods: {
    element_change(payload, index) {
      this.$emit("element_change", { index: index, element: payload });
    },
    elements_changed(a) {
      console.log(a);
      if (a.added) this.$emit("added", a.added);
      if (a.removed) this.$emit("removed", a.removed);
      if (a.moved) this.$emit("moved", a.moved);
    },
    update_col(type, value) {
      this.$emit("update_column", { type: type, value: value });
    },
    reorder_items() {
      this.$emit("update_column", { type: "items", value: this.items_ });
    },
    remove_element(index) {
      this.$emit("remove_element", index);
    },
    remove_column() {
      this.$emit("remove_column");
    },
    add_element() {
      this.$emit("add_element");
    },
  },
};
</script>
